import React, { useEffect, useState } from 'react';
import PlayerMetricsModal from './metrics/PlayerMetricsModal';

export default function PlayerProfile({ playerId, playerName, onClose }) {
  if (!playerId) return null;
  return (
    <PlayerMetricsModal
      playerId={playerId}
      playerName={playerName}
      onClose={onClose}
    />
  );
}